const styles = {
  link: {
    cursor: 'pointer',
  },
};

export default styles;
